(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["botani-facets"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      var grid = document.getElementById('product-grid');
      if (!grid || grid.dataset.botaniBound) return;
      grid.dataset.botaniBound = '1';

      var container = document.getElementById('ProductGridContainer');
      var panel = document.getElementById('BotaniFilters');
      var items = Array.prototype.slice.call(grid.querySelectorAll('.botani-grid-item'));
      var checks = panel ? Array.prototype.slice.call(panel.querySelectorAll('.bf__input')) : [];
      var priceRange = document.getElementById('BotaniPriceRange');
      var priceOut = document.getElementById('BotaniPriceOut');
      var sortSel = document.getElementById('BotaniSort');
      var countEl = document.getElementById('BotaniCount');
      var toggle = document.getElementById('BotaniFilterToggle');
      var overlay = document.getElementById('BotaniFilterOverlay');
      var closeBtn = document.getElementById('BotaniFilterClose');

      function num(el, key) {
        var v = parseFloat(el.getAttribute('data-' + key));
        return isNaN(v) ? 0 : v;
      }

      function sortItems() {
        var v = sortSel ? sortSel.value : 'featured';
        var sorted = items.slice().sort(function (a, b) {
          if (v === 'price-asc') return num(a, 'price') - num(b, 'price');
          if (v === 'price-desc') return num(b, 'price') - num(a, 'price');
          if (v === 'power') return (num(b, 'power') - num(a, 'power')) || (num(b, 'reviews') - num(a, 'reviews'));
          if (v === 'reviews') return num(b, 'reviews') - num(a, 'reviews');
          return num(a, 'feat') - num(b, 'feat');
        });
        sorted.forEach(function (li) { grid.appendChild(li); });
      }

      function apply() {
        var f = { mol: [], type: [], puissance: [], stock: [] };
        checks.forEach(function (c) {
          if (c.checked && f[c.dataset.key]) f[c.dataset.key].push(c.value);
        });
        var maxP = priceRange ? parseInt(priceRange.value, 10) : Infinity;

        var visible = 0;
        items.forEach(function (li) {
          var okMol = !f.mol.length || f.mol.indexOf(li.getAttribute('data-mol')) !== -1;
          var okType = !f.type.length || f.type.indexOf(li.getAttribute('data-type')) !== -1;
          var okPuiss = !f.puissance.length || f.puissance.indexOf(li.getAttribute('data-puissance')) !== -1;
          var okStock = !f.stock.length || li.getAttribute('data-available') === '1';
          var okPrice = num(li, 'price') <= maxP;
          var show = okMol && okType && okPuiss && okStock && okPrice;
          li.classList.toggle('bf-hidden', !show);
          if (show) visible++;
        });
        if (countEl) countEl.textContent = visible;
        sortItems();
      }

      function fmtPrice(cents) {
        var v = (parseInt(cents, 10) || 0) / 100;
        try {
          return v.toLocaleString('fr-FR', {
            style: 'currency',
            currency: (priceRange && priceRange.dataset.currency) || 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          });
        } catch (e) {
          return v + ' €';
        }
      }

      /* -------- AJAX pagination (coordinated with the client-side filters) --------
         Fetches a page in the background, swaps the grid items + the pagination
         nav, then re-applies the active filters/sort to the new items. The filter
         checkboxes live in the sidebar (not swapped) so they persist across pages.
         A filter change resets to page 1. */
      function currentPage() {
        var m = window.location.search.match(/[?&]page=(\d+)/);
        return m ? parseInt(m[1], 10) : 1;
      }
      function page1Url() {
        var u = new URL(window.location.href);
        u.searchParams.delete('page');
        return u.pathname + (u.search || '');
      }
      var loading = false;
      function setLoading(on) { loading = !!on; if (container) container.classList.toggle('bf-loading', !!on); }

      function loadPage(url, push) {
        if (loading) return;
        setLoading(true);
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var ng = doc.querySelector('#product-grid');
            if (ng) grid.innerHTML = ng.innerHTML;
            var oldPag = container ? container.querySelector('.pagination-wrapper') : null;
            var newPag = doc.querySelector('.pagination-wrapper');
            if (oldPag && newPag) oldPag.replaceWith(newPag);
            else if (oldPag && !newPag) oldPag.remove();
            else if (!oldPag && newPag && grid.parentNode) grid.parentNode.appendChild(newPag);
            items = Array.prototype.slice.call(grid.querySelectorAll('.botani-grid-item'));
            apply();
            if (push) history.pushState({ botaniPage: 1 }, '', url);
            if (container) {
              var top = container.getBoundingClientRect().top + window.pageYOffset - 100;
              if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
            }
          })
          .catch(function (e) { console.error('[botani-pager]', e); window.location.href = url; })
          .then(function () { setLoading(false); });
      }

      // a filter change re-applies on page 1 (loads it first if we're elsewhere)
      function onFilterChange() {
        if (currentPage() !== 1) loadPage(page1Url(), true);
        else apply();
      }

      checks.forEach(function (c) { c.addEventListener('change', onFilterChange); });
      if (sortSel) sortSel.addEventListener('change', apply);
      if (priceRange) {
        priceRange.addEventListener('input', function () {
          if (priceOut) priceOut.textContent = fmtPrice(priceRange.value);
          apply();
        });
        priceRange.addEventListener('change', onFilterChange);
      }

      // intercept pagination links -> AJAX
      if (container) {
        container.addEventListener('click', function (e) {
          var a = e.target.closest('a.pagination__item');
          if (!a || !a.getAttribute('href') || a.getAttribute('aria-disabled') === 'true') return;
          e.preventDefault();
          loadPage(a.href, true);
        });
      }
      window.addEventListener('popstate', function () { loadPage(window.location.href, false); });

      // mobile drawer
      function openDrawer() {
        if (!panel) return;
        panel.classList.add('is-open');
        if (overlay) { overlay.hidden = false; overlay.classList.add('is-open'); }
        document.body.style.overflow = 'hidden';
      }
      function closeDrawer() {
        if (!panel) return;
        panel.classList.remove('is-open');
        if (overlay) { overlay.classList.remove('is-open'); overlay.hidden = true; }
        document.body.style.overflow = '';
      }
      if (toggle) toggle.addEventListener('click', openDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);

      // Desktop accordion — le CSS scope le visuel à >=750px, donc sur mobile
      // ces toggles sont sans effet visible (panneaux déjà ouverts).
      if (panel) {
        Array.prototype.slice.call(panel.querySelectorAll('.bf__group--acc')).forEach(function (group) {
          var title = group.querySelector('.bf__title');
          if (title) {
            title.addEventListener('click', function () {
              var open = group.classList.toggle('is-open');
              title.setAttribute('aria-expanded', open ? 'true' : 'false');
            });
          }
        });
      }

      apply();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
